import { type Col } from '@pequity/shared/ccp/types';
import { type Component, defineComponent, h } from 'vue';

export type ContentTemplateErrorHandler = (col: Col, error: unknown) => void;

const reportedColIds = new Set<Col['id']>();

export const resetContentTemplateErrorReports = () => reportedColIds.clear();

export const withContentTemplateBoundary = (
  col: Col,
  contentTemplate: Component,
  onTemplateError?: ContentTemplateErrorHandler
) =>
  defineComponent({
    props: { ctx: { type: Object, default: () => ({}) } },
    errorCaptured(error) {
      if (!reportedColIds.has(col.id)) {
        reportedColIds.add(col.id);
        console.error(error);
        try {
          onTemplateError?.(col, error);
        } catch (reporterError) {
          console.error(reporterError);
        }
      }
      return false;
    },
    render() {
      return h(contentTemplate, { ctx: this.ctx });
    },
  });
